﻿/*Usage Uses parent scope  <year-selection year-end=1985 offset=0> or 
         <div data-year-selection data-year-end=1985></div>   */
(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('yearSelection', function () {
            var currentYear = new Date().getFullYear();

            yearSelectionController.$inject = ['$scope', '$attrs'];
            function yearSelectionController($scope, $attrs) {
                $scope.years = [];

                if (typeof $attrs.offset === 'undefined') {
                    $attrs['offset'] = 0;
                }
                if (typeof $attrs.endYear === 'undefined') {
                    $attrs['endYear'] = 1985;// defaults
                }

                var startIndex = $attrs.offset * 1;
                var range = currentYear - $attrs.endYear;

                $scope.years.push('');

                if (startIndex > currentYear || range < 0) {
                    $scope.years.push(currentYear);
                    $scope.selected = $scope.years[0];
                    return;//if offset is greater than current year
                }

                for (var _y = startIndex; _y < range + 1; _y++) {
                    $scope.years.push(currentYear - _y);
                }

                $scope.fields.yearSelected = $scope.years[0];
            }
            return {
                restrict: 'AE',
                replace: false,
                template:
                    '<ui-select id="year"' +
                    'name="year"' +
                    'uis-open-close="onOpenClose(isOpen)"' +
                    'search-enabled="false"' +
                    'aria-required="false"' +
                    'data-ty-ui-select-options' +
                    'data-ng-required="false"' +
                    'ng-model="fields.yearSelected"' +
                    'data-gtm-click ' +
                    'data-gtm-category="ui-select"' +
                    'data-gtm-action="Year"' +
                    'data-gtm-form-submission>' +

                    '<ui-select-match>' +
                    '<span data-ng-bind="$select.selected"></span>' +
                    '</ui-select-match>' +

                    '<ui-select-choices data-simplebar ' +
                    'data-simplebar-auto-hide="false"' +
                    'repeat="year in years track by $index" position="down">' +
                    '<span data-ng-bind="year"></span>' +
                    '</ui-select-choices>' +
                    '</ui-select>',
                controller: yearSelectionController
            };
        });
})(window.angular);